import React from 'react';
import { gql, useQuery } from '@apollo/client';

const RECENT_LISTINGS = gql`
  query DealListingMiniGrid {
    search_deal_listings(per_page: 3) {
      items {
        id
        headline
        industry
        revenue_range_bucket
        masked_owner_name
        confidential
        photo_urls
      }
      total_count
    }
  }
`;

const REVENUE_LABELS = {
  under_500k: 'Under $500K',
  '500k_to_1m': '$500K – $1M',
  '1m_to_5m': '$1M – $5M',
  '5m_plus': '$5M+',
};

const INDUSTRY_LABELS = {
  hvac: 'HVAC',
  restaurant: 'Restaurant',
  retail: 'Retail',
  professional_services: 'Professional Services',
  manufacturing: 'Manufacturing',
  trades: 'Trades',
  health: 'Health',
  auto: 'Auto',
  saas: 'SaaS',
  other: 'Other',
};

export default function DealListingMiniGrid() {
  const { data, loading } = useQuery(RECENT_LISTINGS, { fetchPolicy: 'cache-and-network' });
  const items = data?.search_deal_listings?.items || [];

  if (loading && items.length === 0) {
    return (
      <section className="mb-8">
        <div className="flex items-center justify-between mb-3">
          <h2 className="font-mono text-[11px] uppercase text-muted-foreground tracking-wide">
            Recent listings in your marketplace
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          {[0, 1, 2].map((i) => (
            <div key={i} className="bg-card border border-border rounded-[12px] p-4 h-32 animate-pulse" />
          ))}
        </div>
      </section>
    );
  }

  if (items.length === 0) {
    return (
      <section className="mb-8">
        <div className="bg-card border border-border rounded-[12px] p-5 flex items-center justify-between">
          <div>
            <h2 className="font-semibold text-foreground">No listings yet</h2>
            <p className="text-sm text-muted-foreground mt-1">
              Be the first to list your business on the Succeedo marketplace.
            </p>
          </div>
          <a
            href="/succeedo/deal-room/new"
            className="bg-foreground text-background rounded-full px-5 py-[9px] text-sm hover:bg-foreground/90 transition-colors whitespace-nowrap"
          >
            List your business
          </a>
        </div>
      </section>
    );
  }

  return (
    <section className="mb-8">
      <div className="flex items-center justify-between mb-3">
        <h2 className="font-mono text-[11px] uppercase text-muted-foreground tracking-wide">
          Recent listings
        </h2>
        <a href="/succeedo/deal-room" className="text-sm text-foreground hover:underline">
          Browse all →
        </a>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {items.map((l) => (
          <a
            key={l.id}
            href={`/succeedo/deal-room/${l.id}`}
            className="bg-card border border-border rounded-[12px] p-4 hover:border-foreground/20 transition-colors block"
          >
            <h3 className="text-[14px] font-semibold text-foreground line-clamp-2 mb-2">
              {l.headline}
            </h3>
            <div className="text-xs text-muted-foreground space-y-1">
              <div>{INDUSTRY_LABELS[l.industry] || l.industry}</div>
              <div>{REVENUE_LABELS[l.revenue_range_bucket] || ''}</div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
